import ms from 'ms';
import { type ValueOf } from 'type-fest';
import { Token } from 'typedi';

export const HttpHeader = {
  AccessControlAllowCredentials: 'Access-Control-Allow-Credentials',
  AccessControlAllowOrigin: 'Access-Control-Allow-Origin',
  ContentType: 'Content-Type',
  SetCookie: 'Set-Cookie',
  XApiKey: 'X-Api-Key',
} as const;

export type HttpHeaderType = ValueOf<typeof HttpHeader>;

export const ContainerTokens = {
  DEFAULT_CONTAINER: new Token<string>('DEFAULT_CONTAINER'),
  ENVIRONMENT_SCHEMA: new Token<string>('ENVIRONMENT_SCHEMA'),
  PERSISTENT_STORAGE_ENGINE: new Token<string>('PERSISTENT_STORAGE_ENGINE'),
  PROCESS_ENV: new Token<string>('PROCESS_ENV'),
};

export const DATA_LOADING_TIMEOUT = ms('60s');
export const DATA_LOADING_TIMEOUT_ERROR_MESSAGE = 'Timeout loading data';
export const LOCAL_STORAGE_INSTANCE_NAME = 'prayerstream-storage';
export const MEMBER_CONTACT_US_URL =
  'https://www.medishare.com/contact-us/members';
